var resgistrationModal = {

	elWrap: $('#registration-modal'),
	formEl: $('#registration-modal-form'),
	errorMessageEl: $('#registration-error-message'),
	formcontent: $('.modal-registration-form-content'),
  thankscontent: $('.modal-registration-thanks-content'),
	closeEl: $('.modal-registration-thanks-content .button'),

	customClose: function() {
		resgistrationModal.closeEl.click(function(e){
			e.preventDefault();
			modal.hide();
		});
	},

	show: function() {
		var timer = resgistrationModal.elWrap.attr('data-triggerdelay') * 1000;
		setTimeout(function(){
			modal.show('#registration-modal');
			resgistrationModal.customClose();
		}, timer);
	},

	submitIt: function() {
		resgistrationModal.formEl.submit(function(e){
			e.preventDefault();
			var _this = $(this);
			if (_this.valid()) {
				var formData = new FormData();
				formData.append('privilege_registration_email', $('#RegisterEmail').val());
				formData.append('privilege_registration_password', $('#RegisterPassword').val());
				formData.append('LanguageNodeID', $('#LanguageNodeID').val());
				formData.append('RegistrationOverlay', true);
				$.ajax({
					url: '/Layout/RegistrationOverlay',
          data: formData,
					processData: false,
					contentType: false,
					type: 'POST',
					dataType: 'json',
					success: function(response){
						resgistrationModal.formcontent.hide();
						resgistrationModal.thankscontent.fadeIn();
					},
					error: function(response) {
						var msg = JSON.stringify(response.responseJSON.message).replace(/\"/g, "");
						if (resgistrationModal.errorMessageEl && msg){
							resgistrationModal.errorMessageEl.html(msg);
							resgistrationModal.errorMessageEl.show();
							$('#RegisterEmail').one("change keyup textInput", function( event ) {
								$('#registration-modal-form').find('input[type=submit]').prop("disabled", false);
								resgistrationModal.errorMessageEl.html('');
								resgistrationModal.errorMessageEl.hide();
							});
						}else{
							console.warn("Registration failure, can't display error message");
						}
					}
				});
			}
		});

	},

	init: function() {
		if (resgistrationModal.elWrap.length && !sessionStorage.getItem('registration-seen')) {
			resgistrationModal.show();
			resgistrationModal.submitIt();
		}
	}
};